import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { mqMin, space, tok } from '@sunwebgroup/ui-components'
import React from 'react'
import { styled } from 'styled-components'
import { Filters } from '../Filters/Filters'
import { List } from './List'

const Wrapper = styled.div`
  background-color: ${tok('semantics_views_tinted_background_color')};
  padding: ${space('primitives_space_16')};
  width: 100%;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: ${space('primitives_space_24')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: ${space('primitives_space_32')};
    overflow-y: auto;
    height: 100%;
  }
`

export function Result() {
  const { isLoading } = useUserReviews()

  if (isLoading) {
    return 'Loading...'
  }

  return (
    <Wrapper>
      <Filters />
      <List />
    </Wrapper>
  )
}

Result.Wrapper = Wrapper
